var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load-more-box"},[(_vm.hasMore)?_c('a-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.handleLoadMore}},[_vm._v(" "+_vm._s(_vm.loading ? '加载中...' : '加载更多')+" ")]):_c('span',{staticClass:"no-more"},[_vm._v("没有更多数据了")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }